import { render, staticRenderFns } from "./ModalPlanos.vue?vue&type=template&id=7c85c80e&scoped=true"
import script from "./ModalPlanos.vue?vue&type=script&lang=js"
export * from "./ModalPlanos.vue?vue&type=script&lang=js"
import style0 from "./ModalPlanos.vue?vue&type=style&index=0&id=7c85c80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c85c80e",
  null
  
)

export default component.exports